<template>
<!-- 开放城市 -->
<section class="viewContainer">
<!--权限设置界面-->
<div class="main_container" style="padding-top:10px">
    <div class="table_container" style="padding-bottom: 50px;">
        <div class="top_desc_contianer title">
        <div class="table_container role_type">开放城市</div>
        </div>
        <el-tree ref="tree" :data="menudata" show-checkbox node-key="uk" class="tree_data lineheighttree"
        :expand-on-click-node="false" :props="defaultProps" :default-checked-keys="alreadyChoose"/>
    </div>
    <div class="gudingdibu">
        <!-- <el-button @click="cancle()">取消</el-button> -->
        <el-button type="danger" @click="saveSeting()">保存</el-button>
        <!-- <el-button type="danger" @click="reset">重 置</el-button> -->
    </div>
</div>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys } from "../../api/newOss";
import { areaopencity } from "../../api/comment";
export default {
    mixins: [alertTrends],
    data() {
    return {
        defaultProps: {
        children: "citys",
        label: "label"
        },
        menudata: [],
        alreadyChoose: [],
        chooseAction: [],
    };
    },
    methods: {
        // 获取开放城市列表
        getmenus() {
            let params = {
            isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
            };
            provincegetcountys(params).then(r => {
                let that = this;
                that.menudata = r.resultObj;
                // 获取已经选的菜单模块
                // that.menudata.forEach(p=>{if(p.pid==4){p.citys.forEach(c=>{c.isopen=1})}})
                that.menudata.forEach(p => {
                    p.uk = p.pid;
                    p.label = p.pname;
                    p.disabled = true
                    p.citys.forEach(c=>{
                        c.uk=p.pid+"_"+c.cid
                        c.label = c.cname;
                        if (c.isopen){
                            // that.alreadyChoose.push(c.uk)
                            c.disabled = true
                        }
                        c.citys = []; // 更改为citys
                        if (c.countys) { // 如果有区县数据，填充到citys数组
                            c.countys.forEach(i => {
                                i.uk = p.pid + "_" + c.cid + "_" + i.scid;
                                i.label = i.scname;
                                // i.disabled = i.isopen ? true : false;
                                if (i.isopen){
                                    that.alreadyChoose.push(i.uk)
                                    i.disabled = true
                                }
                                c.citys.push(i); // 将区县数据添加到citys数组
                            });
                        }
                    })
                })
            });
            // var timer = setInterval(()=>{
            // let arr = document.querySelectorAll(".right_action");
            // if(arr.length>1){
            //     clearInterval(timer)
            //     let arr = document.querySelectorAll(".right_action");
            // arr.forEach(v => {
            //     let prev =v.previousElementSibling;
            //     prev.style.height=prev.style.lineHeight=v.offsetHeight+"px";
            // })
            // }
            // },30)
        },
        // 保存
        saveSeting() {
            // 二次确定弹框提示
            let pids=[];
            let cids=[];
            let scids=[];
            // this.$refs.tree.getCheckedNodes().forEach(i=>{
            //     if(i.isopen==0){
            //         const [pid, cid, scid] = i.uk.split("_")
            //         pids.push(pid)
            //         cids.push(cid)
            //         scids.push(scid)
            //     }
            // })
            let _this = this;
            let checkData = _this.$refs.tree.getCheckedNodes();
            for (let i of checkData) {
                if (!i.isopen) {
                    let uk = i.uk.split("_");
                    let pid = uk[0];
                    let cid = uk[1];
                    let scid = uk[2];
                    pids.push(pid)
                    cids.push(cid)
                    if(scid){
                        scids.push(scid)
                    }
                }
            }
            
            // 去除重复数据
            pids = [...new Set(pids)];
            cids = [...new Set(cids)];
            scids = [...new Set(scids)];

            // this.$refs.tree.getCheckedNodes().forEach(node => {
            //     if (node.isopen === 0) {
            //         const [pid, cid] = node.uk.split("_");
            //         pids.push(pid);
            //         cids.push(cid);
            //         if (node.citys && node.citys.length > 0) {
            //             node.citys.forEach(county => {
            //                 if (county.isopen === 0) {
            //                     scids.push(county.uk.split("_").pop());
            //                 }
            //             });
            //         }
            //     }
            // });

            if(pids.length==0||cids.length==0 || scids.length === 0){
                this.showAlert('没有新增的开放城市或区县');
                return true;
            }
            this.$swal({
                type: "warning",
                text: "重要提示，确定要对当前操作进行保存吗？",
                showCancelButton: true,
                reverseButtons: true, // 添加这一行来反转按钮顺序
                cancelButtonText: "取消",
                confirmButtonText: "确定",
            }).then((res) => {
                if (res.value) {
                    let params = {
                        pids: pids,
                        cids: cids,
                        scids: scids
                    };
                    areaopencity(params).then(r => {
                        if (r.resultCode == 1) {
                            this.showAlert('操作成功', 'success');
                        }
                    });
                }
            });
        },
        // 重置
        reset() {
            this.$refs.tree.setCheckedKeys(this.alreadyChoose);
            // this.alreadyChoose = [];
            // this.chooseAction = [];
        },
    },
    mounted() {
        this.getmenus();
    },
};
</script>
<style scoped>
.role_type {
    width: 310px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    color: #555;
}
.role_desc {
    flex: 2;
    -ms-flex: 2;
    -webkit-box-flex: 2;
    height: 100%;
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
    color: #555;
    display: -webkit-box;
    display: -ms-flexbox;
    padding-left: 30px;
    box-sizing: border-box;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 34px;
}
.role_auth {
    flex: 1;
    -ms-flex: 1;
    -webkit-box-flex: 1;
    height: 100%;
    color: #555;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
}
.top_desc_contianer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    line-height: 48px;
    border: 1px solid #eee;
    border-bottom: 0;
}
.title {
    font-size: 14px;
    color: #000;
    font-weight: bold;
    background: rgba(180, 191, 207, 0.12);
}
.title .role_auth,
.title .role_type {
    color: #000;
    /* border-left: 1px solid #eee; */
    padding-left: 30px;
}
/* 树操作 */

.el-tree-node__expand-icon {
    color: #0c0c0c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #555;
}
.tree_data .el-tree-node__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    
    cursor: pointer;
    position: relative;
    border: 1px solid #eee;
}
.right_action>div{
    display: flex;
    flex-wrap: wrap;
}
.right_action {
    left: 370px;
    position: absolute;
    border-left: 1px solid #eee;
    padding-left: 30px;
    top: 0;
    height: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// opencity.vue?332ab777